import { render, staticRenderFns } from "./formModuleDetail.vue?vue&type=template&id=06c3d58b&scoped=true&"
import script from "./formModuleDetail.vue?vue&type=script&lang=ts&"
export * from "./formModuleDetail.vue?vue&type=script&lang=ts&"
import style0 from "./formModuleDetail.vue?vue&type=style&index=0&id=06c3d58b&lang=scss&scoped=true&"
import style1 from "./formModuleDetail.vue?vue&type=style&index=1&id=06c3d58b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c3d58b",
  null
  
)

export default component.exports